import { centroid } from "@turf/turf";

export { _handlePingUpdate as handlePingUpdate };

let animatedPing = {
  name: "ping",
  framesPerSecond: 120,
  initialOpacity: 1,
  opacity: 1,
  initialRadius: 4,
  radius: 4,
  maxRadius: 40,
};

const _animatePingOnMap = (map) => {
  const LAYER = map.getLayer(animatedPing.name);

  if (typeof LAYER !== "undefined") {
    animatedPing.interval = setInterval(() => {
      animatedPing.radius +=
        (animatedPing.maxRadius - animatedPing.radius) /
        animatedPing.framesPerSecond;
      animatedPing.opacity -= 0.9 / animatedPing.framesPerSecond;

      if (animatedPing.opacity < 0) {
        animatedPing.opacity = 0;
      }

      map.setPaintProperty(
        animatedPing.name,
        "circle-radius",
        animatedPing.radius
      );
      map.setPaintProperty(
        animatedPing.name,
        "circle-opacity",
        animatedPing.opacity
      );

      if (animatedPing.opacity <= 0) {
        animatedPing.radius = animatedPing.initialRadius;
        animatedPing.opacity = animatedPing.initialOpacity;
      }
    }, 1000 / animatedPing.framesPerSecond);
  }
};

const _removeAnimatedPingFromMap = (map) => {
  if (animatedPing) {
    if (animatedPing.interval) {
      clearInterval(animatedPing.interval);
    }
    if (map.getLayer(animatedPing.name)) {
      map.removeLayer(animatedPing.name);
    }
    if (map.getSource(animatedPing.name)) {
      map.removeSource(animatedPing.name);
    }
  }
};

const _addAnimatedPingToMap = (map, pingInfo, aboveLayer) => {
  const CENTROID = centroid(pingInfo.feature);
  let source = CENTROID.geometry;

  animatedPing.color = pingInfo.color ? pingInfo.color : "#007cbf";

  map.addSource(animatedPing.name, {
    type: "geojson",
    data: source,
  });

  let layerOpts = {
    id: animatedPing.name,
    source: animatedPing.name,
    type: "circle",
    paint: {
      "circle-radius": animatedPing.initialRadius,
      "circle-radius-transition": { duration: 0 },
      "circle-opacity-transition": { duration: 0 },
      "circle-color": animatedPing.color,
    },
  };
  if (aboveLayer) {
    map.addLayer(layerOpts, aboveLayer);
  } else {
    map.addLayer(layerOpts);
  }

  animatedPing.hasPing = true;
  _animatePingOnMap(map);
};

const _handlePingUpdate = (map, pingInfo) => {
  _removeAnimatedPingFromMap(map);

  if (pingInfo) {
    let layers = map.getStyle().layers;
    let lastCompositeLayer = 0;
    for (let i = 0; i < layers.length; i++) {
      if (layers[i].source === "composite") {
        lastCompositeLayer = i;
      }
    }
    let aboveLayer = null;
    if (
      lastCompositeLayer &&
      layers[lastCompositeLayer + 1] &&
      layers[lastCompositeLayer + 1].id
    ) {
      aboveLayer = layers[lastCompositeLayer + 1].id;
    }

    _addAnimatedPingToMap(map, pingInfo, aboveLayer);
  }
};
